import { DependencyList, useMemo } from "react";


export function useNullableCallback<T extends Function>(callback: T | null, deps: DependencyList | undefined) {
    return useMemo(
        () => callback,
        deps,
    );
}
